import { changeAnalyticsFilter } from 'actions/analytics'
import React from 'react'
import { connect } from 'react-redux'

function mapStateToProps(state, props) {
    const { filters, isFetching, counts } = state.analytics
    const filter = filters[props.filterId]
    const count = filter && counts[filter.searchKey]
    return {
        filter,
        count,
        isFetching,
    }
}

export default connect(mapStateToProps, { changeFilter: changeAnalyticsFilter })
